import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import BusinessOverview from './BusinessOverview';
import BusinessRewards from './BusinessRewards';
import BusinessRedemptions from './BusinessRedemptions';
import BusinessQR from './BusinessQR';

class BusinessPortal extends Component {
  render() {
    const { match } = this.props;
    return (
      <Switch>
        <Route path={`${match.path}/rewards`} component={BusinessRewards} />
        <Route path={`${match.path}/redemptions`} component={BusinessRedemptions} />
        <Route path={`${match.path}/qr`} component={BusinessQR} />
        <Route exact path={match.path} component={BusinessOverview} />
      </Switch>
    );
  }
}

BusinessPortal.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default BusinessPortal;
